/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it


import './src/styles/themify-icons.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/mobile-menu.css'
import './src/styles/404.css'
import './src/styles/custom.css'